import { render } from "./configuracao.vue?vue&type=template&id=5213d50f"
import script from "./configuracao.vue?vue&type=script&lang=js"
export * from "./configuracao.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__